/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import addArticleSearchSource from './addArticleSearchSource';
import addArticlesPage from './addArticlesPage';
import disableEnterSearch from './disableEnterSearch';
import { slug } from '../common';

app.initializers.add(
	slug,
	() => {
		addArticleSearchSource();
		addArticlesPage();
		disableEnterSearch();
	},
	-1
);

import articlesCompat from './compat';
import { compat } from '@flarum/core/forum';

Object.assign(compat, articlesCompat);

export { default as extend } from './extend';
